import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { statusCode } from 'app/auth/models/commonEnum';
import { DashboardService } from 'app/main/dashboard/dashboard.service';
import { environment } from 'environments/environment';
import {  SwiperComponent,
  SwiperDirective,
  SwiperConfigInterface,
  SwiperScrollbarInterface,
  SwiperPaginationInterface } from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HomeComponent implements OnInit {
  public contentHeader: object;
  public relatedProducts;
  public keyRelatedProducts;

  dashboardCount: any[] = [];
  documentURL: any;
  // Swiper
  public swiperResponsive: SwiperConfigInterface = {
    loop: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    autoplay: {
      delay: 3000,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
    breakpoints: {
      1024: {
        slidesPerView: 1,
        //spaceBetween: 40
      },
      768: {
        slidesPerView: 1,
        //spaceBetween: 30
      },
      640: {
        slidesPerView: 1,
        //spaceBetween: 20
      },
      320: {
        slidesPerView: 1,
        //spaceBetween: 10
      }
    }
  };
  constructor(private _dashboardService: DashboardService, private _router: Router) { }

  ngOnInit(): void {
    this.documentURL = environment.documentURL;
    let token =  localStorage.getItem('token');
    if(token != null || token != '')
    {
      this._router.navigate(['/my-application']);
    }
    this.relatedProducts = [
      {
        "src":"assets/images/main-home-slider/slider1.jpg",
      },
      {
          "src":"assets/images/main-home-slider/slider2.jpg",
      },
      {
          "src":"assets/images/main-home-slider/slider3.jpg",
      },
      {
        "src":"assets/images/main-home-slider/slider4.jpg",
      },
      {
        "src":"assets/images/main-home-slider/slider5.jpg",
      },
      {
        "src":"assets/images/main-home-slider/slider6.jpg",
      }
    ];
    this.keyRelatedProducts = [
      {
        "src":"assets/images/main-home-slider/Group 143.png",
      },
      {
        "src":"assets/images/main-home-slider/Group 144.png",
      },
      {
        "src":"assets/images/main-home-slider/Group 145.png",
      },
    ];

      // content header
    this.contentHeader = {
      headerTitle: 'Home',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Home',
            isLink: true,
            link: '/home'
          },
          // {
          //   name: 'eCommerce',
          //   isLink: true,
          //   link: '/'
          // },
          // {
          //   name: 'Shop',
          //   isLink: true,
          //   link: '/'
          // },
          // {
          //   name: 'Details',
          //   isLink: false
          // }
        ]
      }
    };

    this.getDashboardCount()
  }

  // get dashboard count
  getDashboardCount() {
    this._dashboardService.getDashboardDetails().subscribe((result: any) => {
      if (result.statusCode == statusCode.SUCCESS) {
        this.dashboardCount = result["data"]["response"];
        console.log(this.dashboardCount);
      }
    })
  }

  private scrollbar: SwiperScrollbarInterface = {
    el: '.swiper-scrollbar',
    hide: true,
    draggable: true
};

private pagination: SwiperPaginationInterface = {
    el: '.swiper-pagination',
    clickable: true,
    hideOnClick: false
};

public toggleKeyboardControl(): void {
  this.swiperResponsive.keyboard = !this.swiperResponsive.keyboard;
}

public toggleMouseWheelControl(): void {
  this.swiperResponsive.mousewheel = !this.swiperResponsive.mousewheel;
}

public onIndexChange(index: number): void {
  console.log('Swiper index: ', index);
}

public onSwiperEvent(event: string): void {
  console.log('Swiper event: ', event);
}

  @ViewChild(SwiperComponent) componentRef?: SwiperComponent;
  @ViewChild(SwiperDirective) directiveRef?: SwiperDirective;
}
function getDashboardCount() {
  throw new Error('Function not implemented.');
}

